<template>
  <div class="d-md-none" style="margin-bottom: 57px; z-index: 500">
    <v-app-bar fixed>
      <v-badge
        class="mr-4"
        :content="$store.getters['notifications_count']"
        :value="$store.getters['notifications_count']"
        color="blue"
        overlap
        v-if="$store.getters['isLoggedIn']"
      >
        <v-icon @click="openNotifications">fa-bell</v-icon>
      </v-badge>
      <v-badge
        class="mr-4"
        :content="newsLetterBell"
        :value="newsLetterBell"
        color="blue"
        overlap
        v-else
      >
        <v-icon @click="openNewsletter">fa-bell</v-icon>
      </v-badge>

      <v-spacer></v-spacer>
      <span class="logofont text-center">
        <router-link to="/" class="nolink">
          <img src="/vp_nopad.png" style="width: 180px; height: auto" />
        </router-link>
      </span>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer temporary clipped app right v-model="drawer">
      <v-list-item to="/about">
        <v-list-item-icon>
          <img style="height: 24px; width: 28px" class="mb-1" src="/logo.png" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'About Us'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="goTo('about')">
        <v-list-item-icon>
          <v-icon color="black">fa-wrench</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'Features'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="goTo('pricing')">
        <v-list-item-icon>
          <v-icon color="black">fa-dollar-sign</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'Pricing'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/portals" v-if="$store.getters['isLoggedIn']">
        <v-list-item-icon>
          <v-icon color="black">fa-desktop</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'My Portals'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/subscription" v-if="$store.getters['isTrial']">
        <v-list-item-icon>
          <v-icon color="black">fa-user-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'Subscribe'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        @click="$store.dispatch('loadBilling')"
        v-if="!$store.getters['isTrial'] && $store.state.user.subscribed"
      >
        <v-list-item-icon>
          <v-icon color="black">fa-wallet</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <a href id="billing-mobile" style="display: none" target="_blank"></a>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'Billing'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list-item to="/admin/users" v-if="$store.getters['isAdmin']">
        <v-list-item-icon>
          <v-icon color="black">fa-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'Admin'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="logout" class v-if="$store.getters['isLoggedIn']">
        <v-list-item-icon>
          <v-icon color="black">fa-walking</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'Sign Out'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/login" class v-if="!$store.getters['isLoggedIn']">
        <v-list-item-icon>
          <v-icon color="black">fa-user</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="'Sign Up'"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "NavigationMobile",
  data() {
    return { drawer: false, newsletter_prompted: false };
  },
  computed: {
    newsLetterBell() {
      if (this.newsletter_prompted) {
        return null;
      }
      if (localStorage.getItem("newsletter_prompted")) {
        return null;
      }
      return 1;
    },
  },
  methods: {
    goTo(hash) {
      this.drawer = false;
      if (this.$route.name === "Home") {
        this.$vuetify.goTo(`#${hash}`, { offset: -54 });
      } else {
        this.$router.push(`/#${hash}`);
      }
    },
    logout() {
      this.$store.commit("logout");
      this.$router.push("/");
    },
    openNotifications: function () {
      this.$eventBus.$emit("show_notifications");
    },
    openNewsletter: function () {
      if (this.$store.getters["isLoggedIn"]) {
        this.openNotifications();
      } else {
        localStorage.setItem("newsletter_prompted", new Date().getTime());
        this.newsletter_prompted = true;
        this.$eventBus.$emit("show_newsletter");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Arial Rounded MT Bold";
  src: url("/fonts/ArialRoundedMTBold.ttf"),
    url("/fonts/ArialRoundedMTBold.eot?"), url("/fonts/ArialRoundedMTBold.svg");
}

.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 32px;
  letter-spacing: -2px;
}
</style>
